import styled, { css } from 'styled-components';

import { ColumnProps } from './Column';
import { flexGap } from '../../../utils/flexGap';

export const ColumnContainer = styled.div<ColumnProps>`
	${({ $gap, $reverse, $hcenter, $vcenter, $spaceBetween, $fillHeight }) => css`
		display: flex;
		flex-direction: column;
		${flexGap(`${$gap}px`, false)}
		${$hcenter && 'align-items: center'};
		${$vcenter && 'justify-content: center'};
		${$spaceBetween && 'justify-content: space-between'};
		${$reverse && 'flex-flow: column-reverse'};
		width: 100%;
		${$fillHeight && 'height: 100%'};
	`}
`;
